import {
  ClassLessonItem,
  ClassLessonSubjectItem,
} from '../../../constants/types/lms/take-class/type';
import ClassLessonCard from './ClassLessonCard';

interface ClassLessonListProps {
  bookCode: string;
  lessons: ClassLessonItem[];
  onPptClick?: (
    lesson: ClassLessonItem,
    subject: ClassLessonSubjectItem,
  ) => void;
  onVideoClick?: (
    lesson: ClassLessonItem,
    subject: ClassLessonSubjectItem,
  ) => void;
  onSelfClick?: (
    lesson: ClassLessonItem,
    subject: ClassLessonSubjectItem,
  ) => void;
}

/**
 * 개편 LMS (교사) - 수업하기 페이지 > 북별 레슨 판넬 > 레슨 목록
 */
const ClassLessonList = ({
  bookCode,
  lessons,
  onPptClick,
  onVideoClick,
  onSelfClick,
}: ClassLessonListProps) => {
  return (
    <div className="flex flex-col gap-4 pb-5">
      {lessons.map((lesson) => (
        <ClassLessonCard
          key={lesson.lesson}
          bookCode={bookCode}
          lesson={lesson}
          onPptClick={onPptClick}
          onVideoClick={onVideoClick}
          onSelfClick={onSelfClick}
        />
      ))}
    </div>
  );
};

export default ClassLessonList;
